import { render, staticRenderFns } from "./ns-numpad.vue?vue&type=template&id=3f936263&"
import script from "./ns-numpad.vue?vue&type=script&lang=js&"
export * from "./ns-numpad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports